import React, { useEffect } from 'react';
import ImageGallery from '../components/gallery/ImageGallery';
import { useGalleryReload } from '../context/GalleryReloadContext';

const HomePage: React.FC = () => {
  // Usar el contexto de recarga para forzar la recarga de imágenes cuando se solicite
  const { reloadTrigger } = useGalleryReload();
  
  // Cambiar el título del documento
  useEffect(() => {
    document.title = 'Canvasoft images for your life';
  }, []);
  
  return (
    <div>
      {/* El key cambiará cuando se solicite una recarga, forzando a ImageGallery a remontarse */}
      <ImageGallery key={`gallery-${reloadTrigger}`} />
    </div>
  );
};

export default HomePage;